// extracted by mini-css-extract-plugin
module.exports = {"container":"DamageInfoBox_container__9FZo9"};